<template>
  <div class="">
    <section class="w-full section">
      <div class="max-w-6xl mx-auto">
        <div class="p-2 xl:p-4">
          <div class="flex lg:mb-5 flex-wrap">
            <div class="w-full md:w-1/3 p-1">
              <p class="text-xl font-black login-blue1-text mb-2">我的點數</p>
              <div class="bg-white mb-1 text-center p-3">
                <div class="max-w-sm mx-auto flex justify-between items-center">
                  <p class="text-lg">現在點數</p>
                  <p class="text-2xl login-purple-text font-black">{{ remainPoints }}</p>
                  <p class="text-lg">點</p>
                </div>

              </div>
              <div class="bg-white text-center p-2">
                <div class="max-w-sm mx-auto text-center">
                  <p class="text-center"><span class="text-gray-700">到期日：</span> <span class="gept_main_color15 font-semibold">{{ user.due_at }}</span></p>
                </div>
              </div>
            </div>
            <div class="w-full md:w-2/3 p-1">
              <p class="text-xl font-black mr-2 login-blue1-text mb-2">輸入序號</p>
              <div class="bg-white flex justify-between items-center text-center p-3">
                <div class="flex-1">
                  <input type="text" class="w-full border p-1 px-2 mb-1" v-model="serialno" placeholder="serial number">
                  <input type="text" class="w-full border p-1 px-2" v-model="password" placeholder="password">
                </div>
                <a class="m-2 inline-block cursor-pointer" @click="checkSerialNumberAvailable()">
                  <img class="object-contain" src="@/assets/image/exchange.png" alt="">
                </a>
              </div>
            </div>
          </div>
          <!-- <div class="flex items-center flex-wrap mb-3">
            <p class="text-xl font-black mr-2 login-blue1-text">使用紀錄</p>
            <div class="relative mx-2">
              <select class="block appearance-none w-full border border-gray-400 py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500" id="filterBtn"
                >
                <option value="0">選擇時間區間</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
              </div>
            </div>
            <div class="relative mx-2">
              <select class="block appearance-none w-full border border-gray-400 py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500" id="filterBtn"
                >
                <option value="0">點數花費</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
              </div>
            </div>
            <div class="relative mx-2">
              <select class="block appearance-none w-full border border-gray-400 py-2 px-4 pr-8 rounded leading-tight focus:outline-none bg-white focus:border-gray-500" id="filterBtn"
                >
                <option value="0">項目</option>
              </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 textColorDarkBlack">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
              </div>
            </div>
          </div> -->
          <Table v-if="tableList.datas && tableList.datas.length > 0"
            :columns="tableList.columns"
            :data="tableList.datas">
              <template v-slot:actionsLabel>
                <th class="whitespace-no-wrap text-left bg-white login-blue1-text font-semibold">學習時間</th>
                <th class="whitespace-no-wrap text-left bg-white login-blue1-text font-semibold">項目</th>
                <th class="whitespace-no-wrap text-left lg:text-center bg-white login-blue1-text font-semibold">次數</th>
                <th class="whitespace-no-wrap text-left lg:text-center bg-white login-blue1-text font-semibold">點數花費</th>
                <th class="whitespace-no-wrap text-left lg:text-center bg-white login-blue1-text font-semibold">功能</th>
              </template>
              <template slot="actionsBtn" slot-scope="props">
                <td data-th="學習時間" class="text-left">
                  <span class="font-semibold">{{ moment(props.item.created_at).format('YYYY/MM/DD HH:mm:ss') }}</span>
                </td>
                <td data-th="項目" class="text-left">
                  <span class="font-semibold">{{ props.item.name }}</span>
                </td>
                <td data-th="次數" class="text-left lg:text-center">
                  <span class="font-semibold">{{ props.item.times }}</span>
                </td>
                <td data-th="點數花費" class="text-left lg:text-center">
                  <span class="font-semibold" :class="{ 'inc_green': props.item.points_type && props.item.points_type === 'inc' }">{{ props.item.points_type && props.item.points_type === 'inc' ? '+' : '' }}{{ props.item.points_type && props.item.points_type === 'dec' ? '-' : '' }}{{ props.item.points ? props.item.points : 0 }}點</span>
                </td>
                <td data-th="功能" class="text-left lg:text-center">
                  <a class="m-1 inline-block cursor-pointer" @click="checkRecords(props.item)">
                    <img class="object-contain" src="@/assets/image/check_btn.png" alt="">
                  </a>
                </td>
              </template>
          </Table>

          <pagination :pagination="pagination" v-on:selectedPage="selectedPage" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  // import moment from 'moment'
  import { mapGetters } from 'vuex'
  import Table from '@/components/table'
  import api from '@/api.js'
  import pagination from '@/components/pagination'
  export default {
    name: 'Records',
    metaInfo: {
      title: ''
    },
    components: {
      Table,
      pagination
    },
    data () {
      return {
        serialno: null,
        password: null,
        tableList: {
          columns: [],
          datas: [
            {}
          ]
        },

        // pagination
        pagination: {
          currentPage: 1,
          length: 1
        },
        pageSize: 10
      }
    },
    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'ai_sid',
        'ai_uuid',
        'user'
      ])
    },
    watch: {
    },
    mounted () {
      if (this.authorized && !this.ai_sid) {
        this.getPointDeductionRecord()
      }
    },
    methods: {
      getPointDeductionRecord () {
        // 扣點紀錄
        let self = this
        self.$store.dispatch('isLoading', true)
        let path = `/usage_records?page=${self.pagination.currentPage}&pageSize=${self.pageSize}`
        api.get(path)
        .then((res) => {
          self.tableList.datas = res.data.data
          self.pagination.length = res.data.total_pages
          self.$store.dispatch('isLoading', false)
        })
        .catch(() => {
          self.$store.dispatch('isLoading', false)
        })
      },

      checkRecords (item) {
        let self = this
        let chatArr = ['AI_CHAT', 'AI_JAPANESE_SPEAKING_BEGINNER']
        let geptArr = ['AI_GEPT_SPEAKING_BEGINNER', 'AI_GEPT_WRITING_BEGINNER', 'AI_GEPT_SPEAKING_INTERMEDIATE', 'AI_GEPT_WRITING_INTERMEDIATE']
        let speechArr = ['AI_SPEECH', 'AI_LETTER', 'AI_JAPANESE_LETTER', 'AI_JAPANESE_SPEECH']
        if (geptArr.indexOf(item.type) > -1) {
          // GEPT
          self.$router.push({ name: 'gept_report_formal', params: { record_id: item.record_id } })
        } else if (chatArr.indexOf(item.type) > -1) {
          // chat
          let lang = item.type === 'AI_CHAT' ? 'en' : 'jp'
          self.$router.push({ name: 'viewChat', params: { lang: lang }, query: { conversation_id: item.record_id } })
        } else if (speechArr.indexOf(item.type) > -1) {
          let type = item.type === 'AI_SPEECH' || item.type === 'AI_JAPANESE_SPEECH' ? 'speech' : 'letter'
          self.$router.push({ name: 'viewGenerate', params: { aiType: type, promptId: item.record_id } })
        }
      },

      getProductsID (item) {
        let self = this
        let path = `/usage_records/${item.session_id}`
        self.$store.dispatch('isLoading', true)
        api.get(path)
        .then((response) => {
          console.log(response)
          self.$store.dispatch('isLoading', false)
        })
        .catch((err) => {
          self.$store.dispatch('isLoading', false)
        })
      },

      selectedPage (selectedPage) {
        this.pagination.currentPage = selectedPage
        this.getPointDeductionRecord()
      },

      async checkSerialNumberAvailable() {
        if (!this.serialno || !this.password) return;

        this.$store.dispatch('isLoading', true)

        try {
          const path = `/redeem`;
          const res = await api.post(path, { serialno: this.serialno, password: this.password });

          const redeemAmount = res.data.redeem_amount;
          const confirm = await this.showSwal({
            html: `
              <h4>確認兌換AI英語學習教室 ${redeemAmount}點?</h4>
              <p class="mb-2">目前總點數：<span style="color: #F30000;">${this.remainPoints}</span> 點</p>
              <p class="mb-2">增加 ${redeemAmount} 點</p>
              <p class="mb-2">增加後點數 <span style="color: #F30000;">${this.remainPoints + redeemAmount}</span> 點</p>
            `,
            confirmButtonText: `確認`,
            denyButtonText: `取消`
          });

          if (confirm.isConfirmed) {
            await this.redeemSerialNumber();
          }
        } catch (err) {
          this.showSwal({
            html: `<h4>${err.response?.data?.error || '發生錯誤'}</h4>`,
            confirmButtonText: `確認`
          });
        } finally {
          this.$store.dispatch('isLoading', false);
        }
      },

      async redeemSerialNumber() {
        this.$store.dispatch('isLoading', true);

        try {
          const path = `/redeem/${this.serialno}`;
          await api.post(path, { password: this.password });

          await this.$store.dispatch('getRemainPoints');
          this.showSwal({
            html: `<h4>兌換完成</h4>`,
            confirmButtonText: `確認`
          });
        } catch (err) {
          this.showSwal({
            html: `<h4>${err.response?.data?.msg || '兌換失敗'}</h4>`,
            confirmButtonText: `確認`
          });
        } finally {
          this.$store.dispatch('isLoading', false);
        }
      },

      showSwal (options) {
        const defaultOptions = {
          showCloseButton: false,
          showDenyButton: true,
          focusConfirm: true,
          title: '兌換確認',
          denyButtonText: `取消`,
          customClass: {
            title: 'text-white',
            popup: 'p-0',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'save_check my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit',
            denyButton: 'btn-deny order_1'
          }
        }
        return this.$swal.fire({ ...defaultOptions, ...options })
      }
    }
  }
</script>
<style lang="scss" scoped>
section {
  background-color: #EAEDF2;
  min-height: 100vh;
}

.banner-text {
  left: 50%;
  top: 50%;
}
.inc_green {
  color: #19642E;
}
</style>
